import type from './type'
import location from './location'
import connection from './connection'

const node = {
  getById: {
    method: 'get',
    url: '/ws-admincp/node/ID'
  },
  getList: {
    method: 'post',
    url: '/ws-admincp/node/list?archive=ARCHIVE'
  },
  getAll: {
    method: 'post',
    url: '/ws-admincp/node/get-all'
  },
  addNode: {
    method: 'post',
    url: '/ws-admincp/node'
  },
  update: {
    method: 'put',
    url: '/ws-admincp/node'
  },
  updateRelationNode: {
    method: 'post',
    url: '/ws-admincp/node/update-relation-node'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/node'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/node/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/node/restore'
  },
  findNodes: {
    method: 'get',
    url: '/ws-admincp/node/find?key=KEY&type=NODETYPE'
  },
  findNodeByType: {
    method: 'post',
    url: '/ws-admincp/node/find/by-type-id'
  },
  findNodeConnections: {
    method: 'post',
    url: '/ws-admincp/node/findNodeConnection?key=KEY&limit=LIMIT'
  },
  getHistory: {
    method: 'post',
    url: '/ws-admincp/node/history/list'
  },
  getNodeTypes: {
    method: 'get',
    url: '/ws-admincp/node/types'
  },
  getTransportTypes: {
    method: 'get',
    url: '/ws-admincp/node/transport-types'
  },
  getNodeAndWareHouseTypes: {
    method: 'get',
    url: '/ws-admincp/node/node-and-warehouse-types'
  }
}

export default {
  ...node,
  type,
  location,
  connection
}
